import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSliderToggleArrow = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 17,
	viewBox: "0 0 24 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.5 1C8.5 1 7.41386 8.43111 1 8.43111V8.56889C7.41386 8.56889 8.5 16 8.5 16",
		stroke: "black",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.75 8.5L23.5 8.3125",
		stroke: "black",
		strokeWidth: 2
	})]
});
export default SvgSliderToggleArrow;
